@if (uiMode == 'side') {
    <ol-outlet-content-type-side
            [objectIdentifier]="objectIdentifier"
            [dto]="dto"
            [uiMode]="uiMode"
            (onNavigationItems)="handleNavigationItems($event)"
    ></ol-outlet-content-type-side>
} @else {
    <ol-outlet-content-type-full
            [objectIdentifier]="objectIdentifier"
            [dto]="dto"
            [uiMode]="uiMode"
            (onNavigationItems)="handleNavigationItems($event)"
    ></ol-outlet-content-type-full>
}